export const IMAGE_BASE_URI = `${window.location.origin}/images/`;

export const BLURB =
  "Get the geek in your life the perfect present this Christmas - a dice advent calendar! Complete with an online one shot, the KritMiss Advent(ure) Calendar is the best way to satisfy the urge to be a dice goblin and celebrate the silly season at the same time. Stocks are limited, so order early to avoid disappointment";
